export enum CollapsibleListState {
  OPEN = 'Open',
  COLLAPSED = 'Collapsed',
  VOID = 'Void'
}
